export default __webpack_public_path__ + "static/media/365.bcd7d115.png";